import React from 'react'
import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'

import { ANALYTICS_EVENTS, Drawer, useAccountStore, useEvent } from '../../../common'
import { type HelpCopy } from '../../../core'
import { getInstitutionsBasedOnGuid } from '../../utils'
import { PopularTopicsList } from './PopularTopicsList'
import { RequestSupportHeader } from './RequestSupportHeader'

interface PopularTopicsDrawerProps {
  copy: HelpCopy
  isOpen: boolean
  onClick: (title: string) => void
  onClose: () => void
  topic: string
}

export const PopularTopicsDrawer: React.FC<PopularTopicsDrawerProps> = ({
  copy,
  isOpen,
  onClick,
  onClose,
  topic,
}) => {
  const { institutions, accounts } = useAccountStore()
  const { onEvent } = useEvent()
  const institutionsList = React.useMemo(
    () =>
      getInstitutionsBasedOnGuid(institutions, accounts, {
        singular: copy.request_support_institution_account,
        plural: copy.request_support_institution_accounts,
      }),
    [institutions, accounts],
  )

  return (
    <Drawer isOpen={isOpen} onClose={onClose} title={copy.request_support}>
      <Stack>
        <RequestSupportHeader
          hasIcon={false}
          reverse={true}
          subtitle={copy.request_support_institution_short_content}
          title={topic}
        />
        <Text
          color="text.primary"
          fontWeight="bold"
          gutterBottom={true}
          sx={{ ml: 24 }}
          variant="caption"
        >
          {copy.request_support_institution_topic_label}
        </Text>
        <PopularTopicsList
          list={institutionsList}
          onClick={(title) => {
            onEvent(ANALYTICS_EVENTS.HELP_CLICK_SUPPORT_FOR_INSTITUTION, {
              supportTopic: topic,
              supportInstitution: title,
            })

            onClick(title)
          }}
          sx={{ fontWeight: 600 }}
        />
      </Stack>
    </Drawer>
  )
}
